import { apiFetch } from './client';

export interface PartnerConnection {
  id: string;
  partnerId: string;
  label: string;
  direction: 'outbound' | 'inbound' | 'both';
  protocol: string;
  host: string;
  port: number;
  username: string;
  authType: 'ssh_key' | 'password';
  vaultSecretPath: string;
  remoteBasePath: string | null;
  expectedHostKey: string | null;
  lastTestedAt: string | null;
  lastTestStatus: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ConnectionListResponse {
  connections: PartnerConnection[];
}

export interface CreateConnectionPayload {
  partnerId: string;
  label: string;
  direction: 'outbound' | 'inbound' | 'both';
  protocol?: string;
  host: string;
  port?: number;
  username: string;
  authType: 'ssh_key' | 'password';
  vaultSecretPath: string;
  remoteBasePath?: string;
  expectedHostKey?: string;
}

export type UpdateConnectionPayload = Partial<Omit<CreateConnectionPayload, 'partnerId'>>;

export interface TestConnectionResult {
  ok: boolean;
  message?: string;
}

export const connectionsApi = {
  list: (partnerId?: string): Promise<ConnectionListResponse> => {
    const qs = partnerId ? `?partnerId=${encodeURIComponent(partnerId)}` : '';
    return apiFetch<ConnectionListResponse>(`/connections${qs}`);
  },

  get: (id: string): Promise<PartnerConnection> => {
    return apiFetch<PartnerConnection>(`/connections/${id}`);
  },

  create: (data: CreateConnectionPayload): Promise<PartnerConnection> => {
    return apiFetch<PartnerConnection>('/connections', { method: 'POST', data });
  },

  update: (id: string, data: UpdateConnectionPayload): Promise<PartnerConnection> => {
    return apiFetch<PartnerConnection>(`/connections/${id}`, { method: 'PUT', data });
  },

  remove: (id: string): Promise<{ message: string }> => {
    return apiFetch<{ message: string }>(`/connections/${id}`, { method: 'DELETE' });
  },

  test: (id: string): Promise<TestConnectionResult> => {
    return apiFetch<TestConnectionResult>(`/connections/${id}/test`, { method: 'POST' });
  },
};
